import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ReportSettingForm } from "./ReportSettingForm";
import { type ReportSetting } from "@/lib/api/reportSettings";

interface UpdateReportSettingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  reportSetting: ReportSetting | null;
}

export function UpdateReportSettingModal({ isOpen, onClose, onSuccess, reportSetting }: UpdateReportSettingModalProps) {
  const handleSuccess = () => {
    onSuccess();
    onClose();
  };

  if (!reportSetting) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Update Report Setting</DialogTitle>
          <DialogDescription>
            Update the blacklist filter for Dorman adjusted margin report option months
          </DialogDescription>
        </DialogHeader>

        <ReportSettingForm
          mode="update"
          initialData={reportSetting}
          onSuccess={handleSuccess}
          onCancel={onClose}
          showCancelButton={true}
        />
      </DialogContent>
    </Dialog>
  );
}
